import { CLAIM_STATUSES } from '@/common/constants/claims';
import { ROLE_VALUES } from '@/pages/admin/user/components/userForm/constants';

export const chekcSubmitDisabled = (claimStatus, claim, fromSearch, role) => {
	const payDisabledByRole = claim && role === ROLE_VALUES.SUPPORT;

	const payDisabledByStatus = ![
		CLAIM_STATUSES.TO_PAY.value,
		CLAIM_STATUSES.PAID_IN_PROGRESS.value,
		CLAIM_STATUSES.NONE.value,
	].includes(claimStatus);

	const payDisabledBySearch =
		fromSearch && claimStatus !== CLAIM_STATUSES.NONE.value;

	return payDisabledByStatus || payDisabledByRole || payDisabledBySearch;
};
